import { Grid, Typography } from '@mui/material';

import { FormInput } from '../../../components/hook-form/form-input.component';
import { FormSelectDynamic } from '../../../components/hook-form/form-select.dynamic.component';
import { leaveManageApiKeyStore } from '../../../api/leave-manage-api-key-store';
import { FormDateField } from '../../../components/hook-form/form-date.field.component';

export const LeaveRequestForm = () => {
  return (
    <Grid container spacing={2}>
      {/* <Grid item lg={5} sm={5} xl={5} xs={5}>
        <FormSelectDynamic
          name="leaveTypeID"
          label="Leave Type"
          required
          getQueryKeyConfig={() => leaveManageApiKeyStore.getLeaveTypes()}
          optionsValueKey="leaveTypeID"
          optionsLabelKeys={['leaveType']}
        />
      </Grid> */}
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <Grid container spacing={2}>
          <Grid item lg={12} sm={12} xl={12} xs={12}>
            <Typography variant="body1" color="text.secondary">
              Dates of Absence
            </Typography>
          </Grid>
          <Grid item lg={5} sm={5} xl={5} xs={5}>
            <FormDateField label="From Date" name="fromDate" />
          </Grid>
          <Grid item lg={5} sm={5} xl={5} xs={5}>
            <FormDateField label="To Date" name="toDate" />
          </Grid>
        </Grid>
      </Grid>
      {/* <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormInput name="description" label="Description" multiline={true} size={4} />
      </Grid> */}
    </Grid>
  );
};
